import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-tab-selector',
  templateUrl: './tab-selector.component.html',
  styleUrls: ['./tab-selector.component.scss']
})
export class TabSelectorComponent implements OnInit {

  @Input() tabs: Array<SelectItem> = [];
  @Input() active: SelectItem;
  @Input() docMode = false;
  @Output() activeChange = new EventEmitter<SelectItem>();

  constructor() { }

  ngOnInit(): void {
  }

  public onChangeTab(actual: SelectItem): void {
    this.activeChange.emit(actual);
  }

}
